module.exports = __webpack_public_path__ + "static/media/callsupport.66892571.png";